import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-transparency',
  templateUrl: './transparency.component.html',
  styleUrls: ['./transparency.component.scss']
})
export class TransparencyComponent implements OnInit {

  constructor(private router: Router) {
  }

  ngOnInit() {
  }

  gotoPrivacy() {
    this.router.navigateByUrl('privacy');
  }
}
